export default __webpack_public_path__ + "static/media/vr_glasses.f917e746.png";